/*
 * Živá informace o expedici — reaguje na denní dobu, víkend a české státní svátky.
 *
 * Logika je oddělená od DOMu (funkce `zprava`) záměrně, aby se dala otestovat
 * na konkrétních datech bez prohlížeče — svátky a přelomy dne jsou přesně to,
 * co se špatně ověřuje "okem".
 *
 * Čas se bere natvrdo v pásmu Europe/Prague, ne z nastavení návštěvníka.
 */
(function (root) {
  'use strict';

  /*
   * Dny včetně předložky. Ta se nedá připojit zvlášť — před "středu"
   * a "čtvrtek" se říká "ve", jinde "v". Skloňování se navíc liší podle
   * vazby: "expedujeme VE STŘEDU" × "objednejte DO STŘEDY".
   */
  var DNY_V = ['v neděli', 'v pondělí', 'v úterý', 've středu', 've čtvrtek', 'v pátek', 'v sobotu'];
  var DNY_DO = ['do neděle', 'do pondělí', 'do úterý', 'do středy', 'do čtvrtka', 'do pátku', 'do soboty'];
  var MESICE = ['ledna', 'února', 'března', 'dubna', 'května', 'června',
                'července', 'srpna', 'září', 'října', 'listopadu', 'prosince'];

  /* Pevné státní svátky ČR (M-D). */
  var SVATKY_PEVNE = [
    '1-1',   /* Nový rok / Den obnovy samostatného českého státu */
    '5-1',   /* Svátek práce */
    '5-8',   /* Den vítězství */
    '7-5',   /* Cyril a Metoděj */
    '7-6',   /* Jan Hus */
    '9-28',  /* Den české státnosti */
    '10-28', /* Vznik samostatného Československa */
    '11-17', /* Den boje za svobodu a demokracii */
    '12-24', /* Štědrý den */
    '12-25', /* 1. svátek vánoční */
    '12-26'  /* 2. svátek vánoční */
  ];

  /* Velikonoce (Meeus/Jones/Butcher) — Velký pátek a Velikonoční pondělí
     se každý rok posouvají, nejde je zapsat natvrdo. */
  function velikonocniNedele(rok) {
    var a = rok % 19, b = Math.floor(rok / 100), c = rok % 100;
    var d = Math.floor(b / 4), e = b % 4;
    var f = Math.floor((b + 8) / 25), g = Math.floor((b - f + 1) / 3);
    var h = (19 * a + b - d - g + 15) % 30;
    var i = Math.floor(c / 4), k = c % 4;
    var l = (32 + 2 * e + 2 * i - h - k) % 7;
    var m = Math.floor((a + 11 * h + 22 * l) / 451);
    var mesic = Math.floor((h + l - 7 * m + 114) / 31);
    var den = ((h + l - 7 * m + 114) % 31) + 1;
    return new Date(rok, mesic - 1, den);
  }

  function stejnyDen(a, b) {
    return a.getFullYear() === b.getFullYear()
      && a.getMonth() === b.getMonth()
      && a.getDate() === b.getDate();
  }

  function jeSvatek(d) {
    if (SVATKY_PEVNE.indexOf((d.getMonth() + 1) + '-' + d.getDate()) > -1) return true;
    var ne = velikonocniNedele(d.getFullYear());
    var velkyPatek = new Date(ne.getFullYear(), ne.getMonth(), ne.getDate() - 2);
    var pondeli = new Date(ne.getFullYear(), ne.getMonth(), ne.getDate() + 1);
    return stejnyDen(d, velkyPatek) || stejnyDen(d, pondeli);
  }

  function jePracovni(d) {
    var den = d.getDay();
    return den !== 0 && den !== 6 && !jeSvatek(d);
  }

  function pristiPracovni(od) {
    var d = new Date(od.getFullYear(), od.getMonth(), od.getDate());
    for (var i = 0; i < 21; i++) {
      d.setDate(d.getDate() + 1);
      if (jePracovni(d)) return d;
    }
    return d;
  }

  /*
   * Jádro: z času a uzávěrky spočítá, co zákazníkovi napsat.
   * Vrací { stav, head, sub } — bez jakéhokoli dotyku s DOMem.
   */
  /* Den, kdy zásilka odejde ze skladu. */
  function denExpedice(ted, cutoff) {
    if (jePracovni(ted) && ted.getHours() < cutoff) {
      return new Date(ted.getFullYear(), ted.getMonth(), ted.getDate());
    }
    return pristiPracovni(ted);
  }

  /*
   * Odhad doručení = první pracovní den po expedici (PPL doručuje
   * následující pracovní den). Píšeme "obvykle" — je to odhad dopravce,
   * ne závazek, a nechceme slibovat, co neovlivníme.
   */
  function doruceni(ted, cutoff) {
    var d = pristiPracovni(denExpedice(ted, cutoff));
    return 'U vás obvykle ' + DNY_V[d.getDay()] + ' ' + d.getDate() + '. ' + MESICE[d.getMonth()];
  }

  function zprava(ted, cutoff) {
    cutoff = cutoff || 10;

    if (jePracovni(ted) && ted.getHours() < cutoff) {
      var doUzaverky = new Date(ted.getFullYear(), ted.getMonth(), ted.getDate(), cutoff, 0, 0);
      var min = Math.max(0, Math.round((doUzaverky - ted) / 60000));
      var h = Math.floor(min / 60), m = min % 60;
      return {
        stav: 'dnes',
        head: 'Objednejte do ' + cutoff + ':00 a expedujeme ještě dnes',
        sub: 'Zbývá ' + (h > 0 ? h + ' h ' + m + ' min' : m + ' min'),
        doruceni: doruceni(ted, cutoff)
      };
    }

    var dalsi = pristiPracovni(ted);
    var zitra = new Date(ted.getFullYear(), ted.getMonth(), ted.getDate() + 1);

    if (stejnyDen(dalsi, zitra)) {
      return {
        stav: 'zitra',
        head: 'Expedujeme zítra',
        sub: jePracovni(ted)
          ? 'Dnešní uzávěrka v ' + cutoff + ':00 už minula. Objednejte zítra do ' + cutoff + ':00.'
          : 'Objednávejte klidně teď, odešleme hned zítra ráno.',
        doruceni: doruceni(ted, cutoff)
      };
    }

    return {
      stav: 'pozdeji',
      head: 'Expedujeme ' + DNY_V[dalsi.getDay()] + ' ' + dalsi.getDate() + '. ' + MESICE[dalsi.getMonth()],
      sub: 'Objednejte ' + DNY_DO[dalsi.getDay()] + ' ' + cutoff + ':00. Objednávky přijímáme nonstop.',
      doruceni: doruceni(ted, cutoff)
    };
  }

  /* Aktuální čas v Praze poskládaný zpět do Date, aby se počítalo s "nástěnným"
     časem bez ohledu na pásmo návštěvníka. */
  function tedVPraze() {
    try {
      var casti = new Intl.DateTimeFormat('en-GB', {
        timeZone: 'Europe/Prague',
        year: 'numeric', month: '2-digit', day: '2-digit',
        hour: '2-digit', minute: '2-digit', second: '2-digit', hour12: false
      }).formatToParts(new Date());
      var o = {};
      casti.forEach(function (c) { o[c.type] = c.value; });
      var hod = parseInt(o.hour, 10);
      if (hod === 24) hod = 0; /* některé prohlížeče vrací 24 místo 0 */
      return new Date(+o.year, +o.month - 1, +o.day, hod, +o.minute, +o.second);
    } catch (e) {
      return new Date(); /* starý prohlížeč — radši lokální čas než nic */
    }
  }

  var api = {
    zprava: zprava,
    doruceni: doruceni,
    denExpedice: denExpedice,
    jeSvatek: jeSvatek,
    jePracovni: jePracovni,
    pristiPracovni: pristiPracovni,
    velikonocniNedele: velikonocniNedele,
    tedVPraze: tedVPraze
  };

  if (typeof module !== 'undefined' && module.exports) {
    module.exports = api; /* pro testy v Node */
    return;
  }

  root.ilicoExpedice = api;

  function vykresli() {
    var boxy = document.querySelectorAll('[data-ilico-exped]');
    if (!boxy.length) return;

    Array.prototype.forEach.call(boxy, function (box) {
      var cutoff = parseInt(box.getAttribute('data-cutoff'), 10) || 10;
      var z = zprava(tedVPraze(), cutoff);
      var head = box.querySelector('[data-exped-head]');
      var sub = box.querySelector('[data-exped-sub]');

      box.classList.remove('is-dnes', 'is-zitra', 'is-pozdeji');
      box.classList.add('is-' + z.stav);
      if (head) head.textContent = z.head;
      if (sub) sub.textContent = z.sub;
      var dor = box.querySelector('[data-exped-doruceni]');
      if (dor) dor.textContent = z.doruceni || '';
    });
  }

  function start() {
    vykresli();
    /* Přepočet po minutě — ať odpočet nestojí a hláška se sama přepne,
       jakmile uzávěrka uplyne. */
    setInterval(vykresli, 60000);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})(typeof window !== 'undefined' ? window : this);
